import { FALLBACK_LOCALE, isSupportedLocale } from './locales';

/**
 * Choose the locale for a visitor who arrived without one in the URL.
 *
 * Order of evidence, strongest first:
 *   1. a locale they previously chose themselves — an explicit switch outranks
 *      any guess we could make from their browser,
 *   2. their browser's language list, read as BCP-47 so `en-GB` and `en-US`
 *      both resolve to `en`,
 *   3. the fallback locale.
 *
 * Returns a locale code that is always supported.
 */
export function negotiateLocale({ storedLocale, browserLanguages = [] } = {}) {
    if (isSupportedLocale(storedLocale)) {
        return storedLocale;
    }

    const match = browserLanguages
        .map((tag) => String(tag || '').toLowerCase().split('-')[0])
        .find((languageCode) => isSupportedLocale(languageCode));

    return match || FALLBACK_LOCALE;
}
